import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=256f46ee&scoped=true"
import script from "./DetailDrawer.vue?vue&type=script&lang=js"
export * from "./DetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=256f46ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f46ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256f46ee')) {
      api.createRecord('256f46ee', component.options)
    } else {
      api.reload('256f46ee', component.options)
    }
    module.hot.accept("./DetailDrawer.vue?vue&type=template&id=256f46ee&scoped=true", function () {
      api.rerender('256f46ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/EDI/components/DetailDrawer.vue"
export default component.exports